import React from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import HeaderTitle from './components/HeaderTitle';
import { getSpecificActiveFilter } from './components/Filtering/filterHelpers';

function mapStateToProps(state) {
  return {
    segment: state.listingPage.pageSetup.category.segment,
    filterBrand: getSpecificActiveFilter('Brand') || [],
    filterType: getSpecificActiveFilter('Type') || []
  };
}

export default function initPageTitle() {
  const Title = connect(mapStateToProps)(HeaderTitle);
  const mountEl = document.querySelector('[data-component="pageTitle"]');

  if (mountEl) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <Title />
      </Provider>, mountEl
    );
  }
}
